"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getProfileInitials;
/* get user intitials based on profile data */
function getProfileInitials(profile) {
  if (profile) {
    return profile.firstName.substring(0, 1) + profile.lastName.substring(0, 1);
  }
  return null;
}
//# sourceMappingURL=getUserInitials.js.map